import settings from 'config/constants';
import ADMIN from './admin';
import LCRMT from './lcrmt';
import SRMT from './srmt';
import CRMT from './crmt';
import GRMT from './grmt';
import RISK_WEEKLY_REPORT from './riskWeeklyReport';
import { generateAmlNav } from './aml';

const products = settings.PRODUCTS;

export default {
  [products.ADMIN.path]: () => ADMIN,
  [products.RMT.path]: () => SRMT,
  [products.CRMT.path]: () => CRMT,
  [products.LCRMT.path]: () => LCRMT,
  [products.CRMT.path]: () => CRMT,
  [products.GRMT.path]: () => GRMT,
  [products.RISK_WEEKLY_REPORT.path]: () => RISK_WEEKLY_REPORT,
  [products.AML.path]: (config, license, hasOne) => generateAmlNav(config, license, hasOne)
};